export default "__VITE_ASSET__CQHHoEd7__"